import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase-config';
import { buscarRecorridos } from './recorridos360.data';

/* Recorridos 360 de una cámara. Fuente: Firestore `recorridos360/{feedID}` ({ obras: [{ id, titulo, recorridos: [{ fecha,
   url, video?, detalle? }] }] }), que se actualiza solo cada vez que se publica un recorrido nuevo (D:/GSG/r360/guardar360.py),
   sin volver a publicar la plataforma. Mientras carga, o si no hay documento, usa lo que viene en recorridos360.data.js. */
export default function useRecorridos360({ feedID, identifier } = {}) {
  const [obras, setObras] = useState(() => buscarRecorridos({ feedID, identifier }));
  useEffect(() => {
    let vivo = true;
    setObras(buscarRecorridos({ feedID, identifier }));
    // Por feedID; si la cámara todavía no tiene feed, por su identifier (P_xxx).
    const claves = [feedID, identifier].filter(Boolean).map(String);
    if (!claves.length) return undefined;
    (async () => {
      for (const c of claves) {
        const d = await getDoc(doc(db, 'recorridos360', c)).catch(() => null);
        const o = d && d.exists() ? d.data().obras : null;
        if (Array.isArray(o) && o.length) { if (vivo) setObras(o); return; }
      }
    })();
    return () => { vivo = false; };
  }, [feedID, identifier]);
  return obras;
}
